<select
  class="language-selector"
  [class.language-selector--light]="theme === 'light'"
  [class.language-selector--dark]="theme === 'dark'"
  [attr.aria-label]="'menu.language' | translate"
  [ngModel]="currentLanguage"
  (ngModelChange)="useLanguage($event)">
  @for (lang of languages; track lang.value) {
    <option [value]="lang.value">{{ lang.label }}</option>
  }
</select>
